module.exports = __webpack_public_path__ + "media/images/topbild-900-1d6954810bed7566eed32da182760648.jpg";